/**
 * Données SEO des pages métier & ville (longue traîne).
 * Chaque métier a :
 *  - slug URL (kebab-case sans accent)
 *  - label affiché
 *  - h1 (unique)
 *  - intro (texte dense pour Google, ~100 mots)
 *  - missions (liste)
 *  - prerequis (liste)
 *  - mots-clés associés
 */

export const METIERS = {
  "cariste": {
    slug: "cariste",
    label: "Cariste",
    h1: "Emploi Cariste en intérim — Logistique et supply chain",
    intro: "Vous êtes cariste titulaire d'un CACES (catégories 1, 3 ou 5) et cherchez une mission d'intérim dans la logistique ? FR INTERIM recrute des caristes partout en France pour des missions en entrepôt, plateforme logistique, usine ou centre de distribution. Nos entreprises partenaires (agroalimentaire, e-commerce, grande distribution, industrie) proposent des contrats en intérim, CDD et CDI avec des horaires variables (journée, 2x8, 3x8, nuit). Que vous soyez débutant titulaire d'un CACES récent ou cariste expérimenté, inscrivez-vous en quelques minutes et recevez les offres qui correspondent à vos préférences géographiques et à vos disponibilités.",
    missions: [
      "Charger et décharger les camions à l'aide d'un chariot élévateur",
      "Déplacer les palettes vers les zones de stockage",
      "Approvisionner les lignes de production",
      "Utiliser un terminal radio-fréquence pour tracer les mouvements",
      "Contrôler la conformité des marchandises réceptionnées",
      "Respecter les consignes de sécurité et les procédures qualité",
    ],
    prerequis: [
      "CACES 1, 3 ou 5 à jour (selon le poste)",
      "Expérience en entrepôt appréciée (non obligatoire pour juniors)",
      "Rigueur, autonomie et esprit d'équipe",
      "Disponibilité pour horaires en 2x8 ou 3x8 selon les missions",
    ],
    keywords: "emploi cariste, mission intérim cariste, CACES 1 3 5, offre cariste, cariste logistique, recrutement cariste",
  },
  "preparateur-de-commandes": {
    slug: "preparateur-de-commandes",
    label: "Préparateur de commandes",
    h1: "Emploi Préparateur de commandes en intérim — Logistique",
    intro: "FR INTERIM recrute des préparateurs et préparatrices de commandes en intérim dans toute la France. Métier clé de la chaîne logistique, le préparateur de commandes assemble les produits selon les bons de commande, prépare les colis et garantit l'exactitude des expéditions. Nos offres couvrent les secteurs e-commerce, grande distribution, pharmacie, pièces automobiles et industrie, avec ou sans CACES 1 (gerbeur accompagnant). Les missions sont disponibles en journée, 2x8 ou de nuit selon les plateformes partenaires. Profils débutants acceptés : nous proposons un accompagnement et une montée en compétences rapide.",
    missions: [
      "Lire et interpréter les bons de préparation",
      "Prélever les produits dans les zones de stockage (picking)",
      "Emballer, étiqueter et palettiser les commandes",
      "Utiliser un scanner ou un casque vocal (voice-picking)",
      "Contrôler la qualité et la quantité des préparations",
      "Respecter les cadences et les consignes de sécurité",
    ],
    prerequis: [
      "CACES 1 apprécié (non obligatoire pour débutants)",
      "Rigueur et capacité de concentration",
      "Goût du travail en équipe",
      "Disponibilité pour horaires décalés",
    ],
    keywords: "préparateur de commandes, emploi préparateur commande, picking, voice-picking, CACES 1, intérim préparation commandes",
  },
  "manutentionnaire": {
    slug: "manutentionnaire",
    label: "Manutentionnaire",
    h1: "Emploi Manutentionnaire en intérim — Logistique & industrie",
    intro: "Le manutentionnaire est au cœur de l'activité logistique : il charge, décharge, trie, conditionne et déplace les marchandises. FR INTERIM propose des missions d'intérim de manutentionnaire partout en France, adaptées aux débutants comme aux profils expérimentés. Aucun CACES n'est requis pour débuter, mais une bonne condition physique est demandée. Les offres couvrent l'agroalimentaire, la plasturgie, l'industrie, la grande distribution et les plateformes e-commerce. Contrats en intérim, CDD ou CDI, horaires de journée ou en équipe selon les missions.",
    missions: [
      "Chargement et déchargement manuel de camions",
      "Tri et rangement des marchandises",
      "Conditionnement et emballage",
      "Nettoyage et rangement des zones de travail",
      "Aide à l'équipe logistique (filmage de palettes, étiquetage)",
    ],
    prerequis: [
      "Aucun diplôme ni CACES requis",
      "Bonne condition physique",
      "Ponctualité et rigueur",
      "Disponibilité pour horaires décalés",
    ],
    keywords: "manutentionnaire, manutention, emploi manutention, intérim manutentionnaire, agent logistique, aide logistique",
  },
  "agent-logistique": {
    slug: "agent-logistique",
    label: "Agent logistique",
    h1: "Emploi Agent logistique en intérim — Entrepôt et supply chain",
    intro: "L'agent logistique est un profil polyvalent indispensable au bon fonctionnement des entrepôts. FR INTERIM recrute des agents logistiques en intérim, CDD et CDI dans toute la France pour des missions alliant manutention, préparation de commandes et gestion de stocks. Le poste peut nécessiter un CACES selon l'équipement utilisé. Nos clients (plateformes e-commerce, entrepôts frigorifiques, distributeurs, industriels) offrent des environnements de travail modernes avec possibilité d'évolution.",
    missions: [
      "Réceptionner, contrôler et ranger les marchandises",
      "Préparer les commandes et expéditions",
      "Tenir à jour les stocks dans le WMS (système de gestion)",
      "Participer aux inventaires",
      "Respecter les procédures qualité et sécurité",
    ],
    prerequis: [
      "CACES 1, 3 ou 5 apprécié selon le poste",
      "Maîtrise basique de l'informatique",
      "Polyvalence et autonomie",
      "Disponibilité pour horaires en équipe",
    ],
    keywords: "agent logistique, agent de quai, agent entrepôt, emploi logistique, intérim agent logistique",
  },
  "chef-equipe-logistique": {
    slug: "chef-equipe-logistique",
    label: "Chef d'équipe logistique",
    h1: "Emploi Chef d'équipe logistique en intérim — Encadrement entrepôt",
    intro: "Vous avez une expérience significative en logistique et souhaitez évoluer vers l'encadrement ? FR INTERIM recrute des chefs d'équipe logistique pour des missions d'intérim longue durée, CDD et CDI. Vous managez une équipe de caristes, préparateurs et manutentionnaires, suivez les indicateurs de performance (productivité, qualité, sécurité) et animez les équipes au quotidien. Nos partenaires recherchent des managers terrain, pragmatiques, avec un excellent relationnel et un sens aigu de l'organisation.",
    missions: [
      "Animer une équipe de 5 à 20 opérateurs logistiques",
      "Organiser le planning et répartir les tâches",
      "Suivre les KPI : productivité, qualité, sécurité",
      "Former les nouveaux entrants et faire monter en compétences",
      "Reporter au responsable d'exploitation",
    ],
    prerequis: [
      "Minimum 3 ans d'expérience en logistique",
      "CACES 1, 3 et 5 à jour",
      "Expérience managériale ou forte appétence",
      "Maîtrise des outils bureautiques et WMS",
    ],
    keywords: "chef d'équipe logistique, manager logistique, encadrement entrepôt, team leader logistique, intérim manager supply chain",
  },
};

/** Villes cibles pour le SEO longue traîne (top 12 villes logistiques en France). */
export const VILLES = {
  "paris": { slug: "paris", label: "Paris", region: "Île-de-France", code_postal_prefix: "75" },
  "lyon": { slug: "lyon", label: "Lyon", region: "Auvergne-Rhône-Alpes", code_postal_prefix: "69" },
  "marseille": { slug: "marseille", label: "Marseille", region: "Provence-Alpes-Côte d'Azur", code_postal_prefix: "13" },
  "toulouse": { slug: "toulouse", label: "Toulouse", region: "Occitanie", code_postal_prefix: "31" },
  "lille": { slug: "lille", label: "Lille", region: "Hauts-de-France", code_postal_prefix: "59" },
  "bordeaux": { slug: "bordeaux", label: "Bordeaux", region: "Nouvelle-Aquitaine", code_postal_prefix: "33" },
  "nantes": { slug: "nantes", label: "Nantes", region: "Pays de la Loire", code_postal_prefix: "44" },
  "strasbourg": { slug: "strasbourg", label: "Strasbourg", region: "Grand Est", code_postal_prefix: "67" },
  "rennes": { slug: "rennes", label: "Rennes", region: "Bretagne", code_postal_prefix: "35" },
  "orleans": { slug: "orleans", label: "Orléans", region: "Centre-Val de Loire", code_postal_prefix: "45" },
  "rouen": { slug: "rouen", label: "Rouen", region: "Normandie", code_postal_prefix: "76" },
  "vaux-le-penil": { slug: "vaux-le-penil", label: "Vaux-le-Pénil", region: "Île-de-France", code_postal_prefix: "77" },
};

export const METIERS_LIST = Object.values(METIERS);
export const VILLES_LIST = Object.values(VILLES);
